export default "__VITE_ASSET__1c0e0beb__"